const Modal = (props) => {
    return (
        <div class="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{props.title}</h4>
                    </div>
                    <div class="modal-body">
                        <p>{props.body}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" onClick={() => props.handleConfirm()}>{props.confirmBtnText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;